import { MAP_ELEMENT_TYPES } from '../../../constants';

export const MAP_ELEMENT_WIDTH = 120;
export const MAP_ELEMENT_HEIGHT = 30;

const MAP_ELEMENT_OUT_BORDER_RADIUS = 5;
const MAP_ELEMENT_BORDER_RADIUS = 0.7;

export const GROUP_ELEMENT_WIDTH = 400;
export const GROUP_ELEMENT_HEIGHT = 100;

const COLOR_OUTCOME = '#4b4b4b';

const COLOR_START = '#9BD5B9';
const COLOR_PAGE = '#3392DB';
const COLOR_STEP = '#67ABE1';
const COLOR_DECISION = '#0EA076';
const COLOR_OPERATOR = '#157E56';
const COLOR_MESSAGE = '#235A41';
const COLOR_LOAD = '#FA4B6D';
const COLOR_SAVE = '#C73D58';
const COLOR_DELETE = '#8A3243';
const COLOR_SWIMLANE = '#EFA037';
const COLOR_GROUP = '#B49BC9';
const COLOR_SUBFLOW = '#808080';
const COLOR_RETURN = '#ABABAB';
const COLOR_NOTE = '#DE6854';
const COLOR_BORDER_NOTE = '#ba4432';

export const COLOUR_MAPPINGS = {
    outcome: COLOR_OUTCOME,
    start: COLOR_START,
    input: COLOR_PAGE,
    step: COLOR_STEP,
    decision: COLOR_DECISION,
    operator: COLOR_OPERATOR,
    message: COLOR_MESSAGE,
    database_load: COLOR_LOAD,
    database_save: COLOR_SAVE,
    database_delete: COLOR_DELETE,
    swimlane: COLOR_SWIMLANE,
    group: COLOR_GROUP,
    subflow: COLOR_SUBFLOW,
    return: COLOR_RETURN,
    note: COLOR_NOTE,
};

const baseStyles = {
    mapElement: {
        width: MAP_ELEMENT_WIDTH,
        height: MAP_ELEMENT_HEIGHT,
    },
    outBorder: {
        x: -MAP_ELEMENT_OUT_BORDER_RADIUS,
        y: -MAP_ELEMENT_OUT_BORDER_RADIUS,
        width: MAP_ELEMENT_WIDTH + (MAP_ELEMENT_OUT_BORDER_RADIUS * 2),
        height: MAP_ELEMENT_HEIGHT + (MAP_ELEMENT_OUT_BORDER_RADIUS * 2),
        stroke: '#9c9c9c',
        rx: 1,
        strokeWidth: 0.7,
        strokeDasharray: 2,
        fillOpacity: 0,
    },
    border: {
        width: MAP_ELEMENT_WIDTH,
        height: MAP_ELEMENT_HEIGHT,
        fill: '#333', 
        rx: 1,
        strokeWidth: 0,
    },
    fill: {
        x: MAP_ELEMENT_BORDER_RADIUS,
        y: MAP_ELEMENT_BORDER_RADIUS,
        width: MAP_ELEMENT_WIDTH - (MAP_ELEMENT_BORDER_RADIUS * 2),
        height: MAP_ELEMENT_HEIGHT - (MAP_ELEMENT_BORDER_RADIUS * 2),
        fill: '#fff',
        rx: 0.5,
        strokeWidth: 0,
    },
    icon: 'question-sign',
    content: {
        x: 5,
        y: 5,
        height: MAP_ELEMENT_HEIGHT - 10,
        width: MAP_ELEMENT_WIDTH - 10,
    },
    portLeft: {
        foreignObject: {
            x: -10,
            y: (MAP_ELEMENT_HEIGHT - 10) / 2,
            width: 10,
            height: 10,
        },
        glyph: 'arrow-left',
    },
    portRight: {
        foreignObject: {
            x: MAP_ELEMENT_WIDTH,
            y: (MAP_ELEMENT_HEIGHT - 10) / 2,
            width: 10,
            height: 10,
        },
        glyph: 'arrow-right',
    },
    portTop: {
        foreignObject: {
            x: (MAP_ELEMENT_WIDTH - 10) / 2,
            y: -10,
            width: 10,
            height: 10,
        },
        glyph: 'arrow-up',
    },
    portBottom: {
        foreignObject: {
            x: (MAP_ELEMENT_WIDTH - 10) / 2,
            y: MAP_ELEMENT_HEIGHT,
            width: 10,
            height: 10,
        },
        glyph: 'arrow-down',
    },
    deleteIcon: {
        height: 10,
        width: 10,
        x: MAP_ELEMENT_WIDTH + MAP_ELEMENT_OUT_BORDER_RADIUS - (10 / 2),
        y: -MAP_ELEMENT_OUT_BORDER_RADIUS - (10 / 2),
        image: 'remove-sign',
    },
};

const pageStyles = {
    border: {
        fill: COLOR_PAGE,
    },
    icon: 'th',
};

const stepStyles = {
    border: {
        fill: COLOR_STEP,
    },
    icon: 'map-marker',
};

const decisionStyles = {
    border: {
        fill: COLOR_DECISION,
    },
    icon: 'ok',
};

const operatorStyles = {
    border: {
        fill: COLOR_OPERATOR,
    },
    icon: 'cog',
};

const messageStyles = {
    border: {
        fill: COLOR_MESSAGE,
    },
    icon: 'envelope',
};

const loadStyles = {
    border: {
        fill: COLOR_LOAD,
    },
    icon: 'upload',
};

const saveStyles = {
    border: {
        fill: COLOR_SAVE,
    },
    icon: 'download',
};

const deleteStyles = {
    border: {
        fill: COLOR_DELETE,
    },
    icon: 'remove-circle',
};

const subflowStyles = {
    border: {
        fill: COLOR_SUBFLOW,
    },
    icon: 'triangle-bottom',
};

const returnStyles = {
    border: {
        fill: COLOR_RETURN,
    },
    icon: 'triangle-top',
};

const noteStyles = {
    outBorder: {
        x: -MAP_ELEMENT_OUT_BORDER_RADIUS,
        y: -MAP_ELEMENT_OUT_BORDER_RADIUS,
        width: 40,
        height: 40,
        stroke: 'lightgray',
        rx: 1000,
        strokeWidth: 0.7,
        strokeDasharray: 2,
        fillOpacity: 0,
    },
    border: {
        fill: COLOR_BORDER_NOTE,
        width: 30,
        rx: 1000,
    },
    mapElement: {
        height: 30,
        width: 30,
        rx: 1000,
    },
    fill: {
        height: 30 - (MAP_ELEMENT_BORDER_RADIUS * 2),
        width: 30 - (MAP_ELEMENT_BORDER_RADIUS * 2),
        rx: 1000,
        fill: COLOR_NOTE,
    },
    content: {
        height: 30,
        width: 30,
        rx: 1000,
        x: 0,
        y: 0,
    },
};

const startStyles = {
    border: {
        fill: COLOR_START,
    },
    icon: 'flag',
};

const swimlaneStyles = {
    groupElement: {
        width: GROUP_ELEMENT_WIDTH,
        height: GROUP_ELEMENT_HEIGHT,
    },
    outBorder: {
        x: -20,
        y: -20,
        fillOpacity: 0,
        width: GROUP_ELEMENT_WIDTH + 40,
        height: GROUP_ELEMENT_HEIGHT + 40,
    },
    border: {
        width: MAP_ELEMENT_WIDTH,
        height: MAP_ELEMENT_HEIGHT,
        fill: COLOR_SWIMLANE, 
        rx: 1,
        strokeWidth: 0,
        fillOpacity: 0.2,
    },
    fill: {
        x: MAP_ELEMENT_BORDER_RADIUS,
        y: MAP_ELEMENT_BORDER_RADIUS,
        width: MAP_ELEMENT_WIDTH - (MAP_ELEMENT_BORDER_RADIUS * 2),
        height: MAP_ELEMENT_HEIGHT - (MAP_ELEMENT_BORDER_RADIUS * 2),
        fill: '#fff',
        rx: 0.5,
        strokeWidth: 0,
    },
    content: {
        x: 5,
        y: 5,
        height: MAP_ELEMENT_HEIGHT - 10,
        width: MAP_ELEMENT_WIDTH - 10,
    },
    iconRow: {
        height: 10,
        width: 10,
    },
    icon: 'user',
};

const groupStyles = {
    border: {
        fill: COLOR_GROUP,
    },
    icon: 'folder-open',
    iconRow: {
        width: 40,
    },
};

const mergeStyles = (base, overrides) => Object.entries(base).reduce(
    (merged, [key, val]) => ({
        ...merged,
        [key]: typeof val === 'object' ? {
            ...val,
            ...overrides[key],
        } : overrides[key] || val,
    }),
    {},
);

export const getElementStyles = (elementType) => {

    switch (elementType.toLowerCase()) {

    case MAP_ELEMENT_TYPES.start: 
        return mergeStyles(baseStyles, startStyles);

    case MAP_ELEMENT_TYPES.input: 
        return mergeStyles(baseStyles, pageStyles);

    case MAP_ELEMENT_TYPES.step: 
        return mergeStyles(baseStyles, stepStyles);

    case MAP_ELEMENT_TYPES.decision: 
        return mergeStyles(baseStyles, decisionStyles);

    case MAP_ELEMENT_TYPES.operator: 
        return mergeStyles(baseStyles, operatorStyles);
        
    case MAP_ELEMENT_TYPES.message: 
        return mergeStyles(baseStyles, messageStyles);

    case MAP_ELEMENT_TYPES.database_load: 
        return mergeStyles(baseStyles, loadStyles);

    case MAP_ELEMENT_TYPES.database_save: 
        return mergeStyles(baseStyles, saveStyles);

    case MAP_ELEMENT_TYPES.database_delete: 
        return mergeStyles(baseStyles, deleteStyles);

    case MAP_ELEMENT_TYPES.subflow: 
        return mergeStyles(baseStyles, subflowStyles);

    case MAP_ELEMENT_TYPES.return: 
        return mergeStyles(baseStyles, returnStyles);
        
    case MAP_ELEMENT_TYPES.note:
        return mergeStyles(baseStyles, noteStyles);

    case MAP_ELEMENT_TYPES.swimlane: 
        return swimlaneStyles;

    case MAP_ELEMENT_TYPES.group: 
        return mergeStyles(swimlaneStyles, groupStyles);
    

    default:
        return baseStyles;
    }
};
